module.exports = __webpack_public_path__ + "img/news-feed-ua.23f5b205.png";